import { Grid } from '@mui/material';
import { PrimaryButton } from '../../theme/index'
import '../../sass/styles.scss';
import { UseScreen } from '../../hooks/UseScreen.hook';
import { useDispatch } from 'react-redux';
import { modalDeleteAction } from '../../redux/reducers/Modal';
import { useNavigate } from 'react-router-dom';
import { deleteReservationAction } from '../../redux/reducers/Delete';

const Reservation = () => {

  const screenWidth = UseScreen();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const deleteThisReservation = () => {
    dispatch(modalDeleteAction());
    dispatch(deleteReservationAction())
  }

  return (
    <>
        <Grid item xs={ 10 }>
          {
            ( screenWidth > 500 ) ?
              <h5 style={{ margin: '0', marginBottom: '2rem' }}>Eliminar Reserva</h5>
            :
              <h6 style={{ margin: '0', marginBottom: '2rem' }}>Eliminar Reserva</h6>
          }
        </Grid>
        <Grid item xs={ 12 }textAlign='center'>
          {
            ( screenWidth > 500 ) ?
              <h3>¿Está seguro que desea eliminar esta reservación?</h3>
            :
              <h6>¿Está seguro que desea eliminar esta reservación?</h6>
          }
        </Grid>
        <Grid item xs={ 12 } sx={{ mt: 2 }} textAlign='center' className='pr-2'>
            <PrimaryButton onClick={ () => deleteThisReservation() } sx={{ width: '50%', boxShadow: 5 }}>Confirmar</PrimaryButton>
        </Grid>
    </>
  )
}

export default Reservation